
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CartProductSpecificationsDialog extends Serenity.EntityDialog<CartProductSpecificationsRow, any> {
        protected getFormKey() { return CartProductSpecificationsForm.formKey; }
        protected getIdProperty() { return CartProductSpecificationsRow.idProperty; }
        protected getLocalTextPrefix() { return CartProductSpecificationsRow.localTextPrefix; }
        protected getService() { return CartProductSpecificationsService.baseUrl; }
        protected getDeletePermission() { return CartProductSpecificationsRow.deletePermission; }
        protected getInsertPermission() { return CartProductSpecificationsRow.insertPermission; }
        protected getUpdatePermission() { return CartProductSpecificationsRow.updatePermission; }

        protected form = new CartProductSpecificationsForm(this.idPrefix);

    }
}